module.exports = __webpack_public_path__ + "1c2796678eebb691785c19d367851a44.jpg";